import { useEffect, useState } from "react";

export const usePageVisibility = (): boolean => {
  const [active, setActive] = useState(true);

  useEffect(() => {
    const update = () => {
      const visible = document.visibilityState === "visible";
      const focused = document.hasFocus();
      setActive(visible && focused);
    };

    update();

    document.addEventListener("visibilitychange", update);
    window.addEventListener("focus", update);
    window.addEventListener("blur", update);

    return () => {
      document.removeEventListener("visibilitychange", update);
      window.removeEventListener("focus", update);
      window.removeEventListener("blur", update);
    };
  }, []);

  return active;
};

export const usePageActive = (): boolean => {
  const [active, setActive] = useState(true);

  useEffect(() => {
    const compute = () =>
      document.visibilityState === "visible" && document.hasFocus();

    const update = () => setActive(compute());

    update();

    document.addEventListener("visibilitychange", update);
    window.addEventListener("focus", update);
    window.addEventListener("blur", update);
    window.addEventListener("pageshow", update);
    window.addEventListener("pagehide", update);

    return () => {
      document.removeEventListener("visibilitychange", update);
      window.removeEventListener("focus", update);
      window.removeEventListener("blur", update);
      window.removeEventListener("pageshow", update);
      window.removeEventListener("pagehide", update);
    };
  }, []);

  return active;
};